import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from '../../api/axios';
import { AutoComplete } from 'primereact/autocomplete';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';

export default function ProductsEditPage() {

  const navigate = useNavigate();
  const { id } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;
  const toast = useRef(null);

  // FORM STATES
  const [name, setName] = useState('');
  const [brandName, setBrandName] = useState('');
  const [tags, setTags] = useState('');

  const [salePrice, setSalePrice] = useState(null);
  const [salePriceIsVatIncluded, setSalePriceIsVatIncluded] = useState(false);
  const [taxRate, setTaxRate] = useState(20);

  const [calcExclVat, setCalcExclVat] = useState(null);
  const [calcInclVat, setCalcInclVat] = useState(null);
  const [currentStockQuantity, setCurrentStockQuantity] = useState(0);

  const [barcode, setBarcode] = useState('');
  const [unit, setUnit] = useState('');
  const [unitType, setUnitType] = useState(null);
  const [criticalStockQuantity, setCriticalStockQuantity] = useState(0);
  const [description, setDescription] = useState('');
  const [recordStatus, setRecordStatus] = useState(1);

  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [category, setCategory] = useState(null);

  const [loading, setLoading] = useState(true);

  const [categoryIdFromDb, setCategoryIdFromDb] = useState(null);
 
const [unitTypes, setUnitTypes] = useState([]);
const [filteredUnitTypes, setFilteredUnitTypes] = useState([]);
const [unitTypeIdFromDb, setUnitTypeIdFromDb] = useState(null);

useEffect(() => {
  api.get(apiUrl + "Lookups/unit-types")
    .then(res => {
      const arr = res.data?.data ?? res.data ?? []; 
      const list = arr.map(x => ({
        label: x.name,   
        value: x.id    
      }));

      setUnitTypes(list);
      setFilteredUnitTypes(list);
    })
    .catch(() => {});
}, [apiUrl]);
const searchUnitType = (e) => {
  const q = (e.query || "").toLowerCase();
  const filtered = unitTypes.filter(u =>
    (u.label || "").toLowerCase().includes(q)
  );
  setFilteredUnitTypes(filtered);
};
  const filterItems = (arr = [], query = "") =>
    arr.filter(item => (item.label || "").toLowerCase().includes((query || "").toLowerCase()));

  const searchCategory = (e) => {
  const filtered = filterItems(categories, e.query);
  setFilteredCategories(enrichCategories(filtered, e.query));
  };
  
  const [lastPurchase, setLastPurchase] = useState(null);
  // KDV HESABI
  const recalcVatValues = (price = salePrice, vat = taxRate, included = salePriceIsVatIncluded) => {
    if (price == null || vat == null) return;

    let excl, incl;

    if (included) {
      incl = price;
      excl = price / (1 + vat / 100);
    } else {
      excl = price;
      incl = price * (1 + vat / 100);
    }

    setCalcExclVat(excl);
    setCalcInclVat(incl);
  }; 

 useEffect(() => {
  if (unitTypeIdFromDb != null && unitTypes.length > 0) {
    const idNum = Number(unitTypeIdFromDb);
    const match = unitTypes.find(u => u.value === idNum);
    if (match) setUnitType(match);
  }
}, [unitTypeIdFromDb, unitTypes]);

  // 🔥 ÜRÜN DETAYINI ÇEK
  useEffect(() => {
    const loadProduct = async () => {
      try {
        const res = await api.get(apiUrl + `product/get-product/${id}`);
        const d = res.data.data; 
        setLastPurchase(d.lastPurchase ?? null);
        setName(d.name ?? '');
        setBrandName(d.brandName ?? '');
        setTags(d.tags ?? '');

        const isInc = d.salePriceIsVatIncluded ?? false;
        setSalePriceIsVatIncluded(isInc);

        const excl = d.salePriceExclVat ?? 0;
        const incl = d.salePriceInclVat ?? 0;

        // UI fiyatı
        setSalePrice((excl==0 || isInc ) ? incl : excl);
 
        // Hesaplanan fiyatlar
        setCalcExclVat(excl);
        setCalcInclVat(incl);
        setCurrentStockQuantity(d.currentStockQuantity ?? 0);

        setTaxRate(d.taxRate ?? 20);
        setBarcode(d.barcode ?? '');
        setUnit(d.unit ?? '');

        setUnitTypeIdFromDb(d.unitTypeId ?? d.unitType ?? null);

        setCriticalStockQuantity(d.criticalStockQuantity ?? 0);
        setDescription(d.description ?? '');
        setRecordStatus(d.recordStatus ?? 1);

        setCategoryIdFromDb(d.categoryId);
        // kategori geçici saklanır / setCategory daha sonra yapılır
       // setCategory({ label: d.categoryDesc, value: d.categoryId });
 
      } catch (err) {
        console.error(err);
        toast.current?.show({
          severity: 'error',
          summary: 'Hata',
          detail: 'Ürün bulunamadı.',
          life: 3000
        });
      } finally {
        setLoading(false);
      }
    };

    loadProduct();
  }, [apiUrl, id]);

  // 🔥 KATEGORİLERİ ÇEK
  useEffect(() => {
    api.get(apiUrl + 'Category/combo-categories')
      .then(res => {
        const list = (res.data || []).map(x => ({
        label: x.label ?? x.name ?? x.text,   // hangisi geliyorsa
        value: x.value ?? x.id
      }));
        setCategories(list);
        setFilteredCategories(list);
      })
      .catch(() => {});
  }, [apiUrl]);
 
const enrichCategories = (list = [], query = "") => {
  if (!query) return list;

  const exists = list.some(
    c => c.label.toLowerCase() === query.toLowerCase()
  );

  if (!exists) {
    return [
      ...list,
      {
        label: `"${query}" adlı yeni kategori ekle`,
        value: "__create__",
        rawName: query,
        isCreate: true
      }
    ];
  }

  return list;
};

useEffect(() => {
  if (categoryIdFromDb && categories.length > 0) {
    const match = categories.find(c => c.value === categoryIdFromDb);
    if (match) setCategory(match);
  }
}, [categoryIdFromDb, categories]);

  // 🔥 KDV hesaplamasını initial yüklemede 1 kez yap
  useEffect(() => {
    if (loading) return;
    if (salePrice != null) {
      recalcVatValues(salePrice, taxRate, salePriceIsVatIncluded);
    }
  }, [loading]);

  // UPDATE SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    let excl = calcExclVat;
    let incl = calcInclVat;

    // son güvenlik için hesapla
    if (salePrice != null && taxRate != null) {
      if (salePriceIsVatIncluded) {
        incl = salePrice;
        excl = salePrice / (1 + taxRate / 100);
      } else {
        excl = salePrice;
        incl = salePrice * (1 + taxRate / 100);
      }
    }

    const payload = {
      productDto: {
        Id: parseInt(id),
        Name: name,
        BrandName: brandName,
        CategoryId: category?.value,
        Tags: tags,
        SalePrice: salePrice,
        SalePriceIsVatIncluded: salePriceIsVatIncluded,
        TaxRate: taxRate,
        Barcode: barcode,
        Unit: unit,
        UnitTypeId: unitType?.value, 
        CriticalStockQuantity: criticalStockQuantity,
        CurrentStockQuantity: currentStockQuantity,
        Description: description,
        RecordStatus: recordStatus,
        TenantId: 1,
        UserId: 1
      }
    };

    try {
      await api.post(apiUrl + "product/update", payload);
      toast.current.show({
        severity: 'success',
        summary: 'Başarılı',
        detail: 'Ürün güncellendi.',
        life: 2500
      });
      navigate("/products");
    } catch (err) {
      console.error(err);
      alert("Hata: " + (err.response?.data?.message || err.message));
    }
  };

  if (loading) return <Card><p>Yükleniyor...</p></Card>;

  return (
    <>
      {/* TASARIM CSS */}
      <style>
        {`
          body { background-color: #f5f6fa !important; }
          .section-container { display: flex; gap: 20px; margin-bottom: 20px; }
          .section-box { flex: 1; padding: 20px; border-radius: 12px; background: #fff; box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
          .section-header { font-size: 1.05rem; font-weight: 700; margin-bottom: 15px; color: #333; display: flex; align-items: center; }
          .section-header i { font-size: 1.3rem; margin-right: 10px; color: #6366f1; }
          .field-item { margin-bottom: 16px; display: flex; flex-direction: column; }
          .field-label { font-size: .85rem; font-weight: 600; margin-bottom: 6px; }
        `}
      </style>

      <Card
        title={
          <div className="flex justify-content-between align-items-center">
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>Ürün Düzenle</span>
            <div className="flex gap-2">
              <Button label="Geri" icon="pi pi-arrow-left" className="p-button-secondary" onClick={() => navigate("/products")} />
              <Button form="product-form" label="Güncelle" icon="pi pi-check" className="p-button-success" type="submit" />
            </div>
          </div>
        }
      >
        <Toast ref={toast} />

        <form id="product-form" onSubmit={handleSubmit}>
          <div className="section-container">

            {/* 1. BÖLÜM */}
            <div className="section-box">
              <div className="section-header"><i className="pi pi-box"></i> Ürün Bilgileri</div>

              <div className="field-item">
                <label className="field-label">Ürün Adı</label>
                <InputText value={name} onChange={(e) => setName(e.target.value)} required />
              </div>

              <div className="field-item">
                <label className="field-label">Marka</label>
                <InputText value={brandName} onChange={(e) => setBrandName(e.target.value)} />
              </div>

              <div className="field-item">
                <label className="field-label">Kategori</label>
                <AutoComplete
  value={category}
  suggestions={filteredCategories}
  completeMethod={searchCategory}
  field="label"
  dropdown
  appendTo={document.body}
  itemTemplate={(item) =>
  item.isCreate ? (
    <div className="flex items-center gap-2 text-blue-600 font-bold">
      <i className="pi pi-plus-circle"></i>
      {item.label}
    </div>
  ) : (
    <span>{item.label}</span>
  )
}
  onChange={async (e) => {
    const selected = e.value;

    // 🆕 Yeni kategori ekleme
    if (selected?.isCreate) {
      try {
        const res = await api.post(apiUrl + "Category/create", {
          name: selected.rawName
        });

        debugger;
        const newCategory = {
          label: res.data.data.name,
          value: res.data.data.id
        };

        // kategori listesine ekle
        setCategories(prev => [...prev, newCategory]);
        setCategory(newCategory);

        toast.current?.show({
          severity: "success",
          summary: "Kategori eklendi",
          detail: `"${newCategory.label}" oluşturuldu`,
          life: 2000
        });
      } catch (err) {
        toast.current?.show({
          severity: "error",
          summary: "Hata",
          detail: "Kategori eklenemedi",
          life: 3000
        });
      }

      return;
    }

    // normal seçim
    setCategory(selected);
  }}
/>

              </div>

              <div className="field-item">
                <label className="field-label">Etiketler</label>
                <InputText value={tags} onChange={(e) => setTags(e.target.value)} />
              </div>
              <div className="field-item">
                <label className="field-label">Durum</label>
                <Dropdown
                  value={recordStatus}
                  options={[
                    { label: 'Aktif', value: 1 },
                    { label: 'Pasif', value: 0 }
                  ]}
                  onChange={(e) => setRecordStatus(e.value)}
                  placeholder="Seçiniz"
                  className="w-full"
                />
              </div>
               <div className="field-item">
                <label className="field-label">Açıklama</label>
                <InputTextarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3} />
              </div>
            </div>

            {/* 2. BÖLÜM */}
            <div className="section-box">

              <div className="section-header"><i className="pi pi-wallet"></i> Fiyat & KDV</div>

              <div className="field-item">
                <label className="field-label">Satış Fiyatı</label>
                <InputNumber
                  value={salePrice}
                  onValueChange={(e) => {
                    setSalePrice(e.value);
                    recalcVatValues(e.value, taxRate, salePriceIsVatIncluded);
                  }}
                  mode="currency"
                  currency="TRY"
                  locale="tr-TR"
                /> 
              </div> 
             <div
  className={`mt-3 mb-3 p-3 rounded-xl border flex items-center justify-between transition-all
    ${salePriceIsVatIncluded
      ? "!bg-emerald-50 border-emerald-300"
      : "!bg-blue-50 border-blue-300"}`}
>
  <div className="flex items-center gap-3">
    <i
      className={`pi ${
        salePriceIsVatIncluded ? "pi-check-circle" : "pi-calculator"
      } text-xl`}
    />
    <div>
      <div className="text-sm font-black text-slate-800">
        {salePriceIsVatIncluded ? "KDV Dahil Fiyat" : "KDV Hariç Fiyat"}
      </div>
      <div className="text-xs text-slate-500">
        {salePriceIsVatIncluded
          ? "Girilen fiyat KDV içerir"
          : "KDV sonradan hesaplanır"}
      </div>
    </div>
  </div>

  <Checkbox
    checked={salePriceIsVatIncluded}
    onChange={(e) => {
      setSalePriceIsVatIncluded(e.checked);
      recalcVatValues(salePrice, taxRate, e.checked);
    }}
  />
</div>

              <div className="field-item">
                <label className="field-label">KDV Oranı</label>
                <InputNumber
                  value={taxRate}
                  onValueChange={(e) => {
                    setTaxRate(e.value);
                    recalcVatValues(salePrice, e.value, salePriceIsVatIncluded);
                  }}
                  suffix="%"
                />
              </div>
{/* 🔔 SON ALIŞ BİLGİSİ */}
<div
  className="section-box"
  style={{
    background: lastPurchase ? "#f8fafc" : "#fff7ed", // 👈 fark burada
    border: lastPurchase
      ? "1px dashed #c7d2fe"
      : "1px dashed #fed7aa"
  }}
>
  <div className="section-header">
    <i className="pi pi-history"></i> Son Alış Bilgisi
  </div>

  {lastPurchase ? (
    <div style={{ fontSize: ".85rem", lineHeight: 1.6 }}>
      <div>
        <b>Tedarikçi:</b>{" "}
        <span style={{ color: "#1e40af", fontWeight: 600 }}>
          {lastPurchase.supplierName}
        </span>
      </div>

      <div>
        <b>Alış Tarihi:</b>{" "}
        {new Date(lastPurchase.purchaseDate).toLocaleString("tr-TR")}
      </div>

      <div>
        <b>Birim Fiyat:</b>{" "}
        <span style={{ fontWeight: 700 }}>
          {lastPurchase.unitPrice.toLocaleString("tr-TR", {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
          })} ₺
        </span>
      </div>
    </div>
  ) : (
    <div
      style={{

        fontSize: ".85rem",
        fontStyle: "italic",
        color: "#64748b",
        display: "flex",
        alignItems: "center",
        gap: 8
      }}
    >
      <i className="pi pi-info-circle text-blue-400"></i>
      Henüz bu ürün için alış kaydı girilmemiştir.
    </div>
  )}
</div>

             <div className="grid grid-cols-2 gap-3 mt-4">
  {/* KDV HARİÇ */}
  <div
    className={`p-3 rounded-xl border transition-all ${
      !salePriceIsVatIncluded
        ? "!bg-blue-50 border-blue-400 shadow"
        : "!bg-slate-50 border-slate-200"
    }`}
  >
    <div className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
      KDV Hariç
    </div>
    <div className="text-lg font-black text-slate-800 mt-1">
      {calcExclVat?.toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5
      })} ₺
    </div>
 
  </div>

  {/* KDV DAHİL */}
  <div
    className={`p-3 rounded-xl border transition-all ${
      salePriceIsVatIncluded
        ? "!bg-emerald-50 border-emerald-400 shadow"
        : "!bg-slate-50 border-slate-200"
    }`}
  >
    <div className="text-[10px] font-black text-slate-500 uppercase tracking-widest">
      KDV Dahil (%{taxRate})
    </div>
    <div className="text-lg font-black text-slate-800 mt-1">
      {calcInclVat?.toLocaleString("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5
      })} ₺
    </div>
 
  </div>
</div>

            </div>

            {/* 3. BÖLÜM */}
            <div className="section-box">
              <div className="section-header"><i className="pi pi-cog"></i> Diğer Bilgiler</div> 
              <div className="field-item">
                <label className="field-label">Anlık Stok</label>
                <InputNumber
                  value={currentStockQuantity}
                  onValueChange={(e) => setCurrentStockQuantity(e.value)}
                />
              </div>
              <div className="field-item">
                <label className="field-label">Kritik Stok</label>
                <InputNumber
                  value={criticalStockQuantity}
                  onValueChange={(e) => setCriticalStockQuantity(e.value)}
                />
              </div>
              <div className="field-item">
                <label className="field-label">Barkod</label>
                <InputText value={barcode} onChange={(e) => setBarcode(e.target.value)} />
              </div>
              <div className="field-item">
  <label className="field-label">
    Satış Birimi <span style={{ color: "#94a3b8", fontWeight: 500 }}></span>
  </label>

  <AutoComplete
     value={unitType}
    suggestions={filteredUnitTypes}
    completeMethod={searchUnitType}
    onChange={(e) => setUnitType(e.value)}
    field="label"
    dropdown
    appendTo={document.body}
    placeholder="Birim seçiniz..." 
  />

  <small style={{ color: "#64748b", marginTop: 6 }}>
    Örn: Un → kg · Zeytinyağı → lt · Çikolata → adet
  </small>
</div> 
{/*
              <div className="field-item">
                <label className="field-label">Birim (Paket İçerisindeki Miktar Örn:Tablet 500mg)</label>
                <InputText value={unit} onChange={(e) => setUnit(e.target.value)} />
              </div>

              <div className="field-item">
                <label className="field-label">Birim Tipi</label>
                <AutoComplete
                  value={unitType}
                  suggestions={filteredUnitTypes}
                  completeMethod={searchUnitType}
                  onChange={(e) => setUnitType(e.value)}
                  field="label"
                  dropdown
                />
              </div>*/
}
           {(() => {
  const current = Number(currentStockQuantity ?? 0);
  const critical = Number(criticalStockQuantity ?? 0);
  const isLow = critical > 0 && current <= critical;
  const unitLabel = unitType?.label || "";  

  return (
    <div
      style={{
        background: isLow ? "#fff1f2" : "#f8fafc",
        border: `1px dashed ${isLow ? "#fecdd3" : "#c7d2fe"}`,
        padding: 16,
        borderRadius: 12,
        marginBottom: 16
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 10
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8, fontWeight: 700 }}>
          <i className="pi pi-chart-bar" style={{ color: "#6366f1" }}></i>
          Stok Bilgisi
        </div>

        <span
          style={{
            fontSize: 12,
            fontWeight: 800,
            padding: "4px 10px",
            borderRadius: 999,
            border: `1px solid ${isLow ? "#fecdd3" : "#a7f3d0"}`,
            background: isLow ? "#fff1f2" : "#ecfdf5",
            color: isLow ? "#9f1239" : "#065f46"
          }}
        >
          {isLow ? "Kritik" : "Normal"}
        </span>
      </div>

      <div style={{ fontSize: "1.6rem", fontWeight: 900, color: "#0f172a" }}>
        {current.toLocaleString("tr-TR")}
        {unitLabel && (
          <span style={{ fontSize: ".9rem", fontWeight: 700, color: "#64748b", marginLeft: 6 }}>
            {unitLabel}
          </span>
        )}
      </div>

      <div style={{ fontSize: ".85rem", color: "#64748b", marginTop: 6 }}>
        Kritik seviye: {critical.toLocaleString("tr-TR")}
        {unitLabel ? ` ${unitLabel}` : ""}
      </div>
    </div>
  );
})()}

             
            </div>

          </div>

        </form>
      </Card>
    </>
  );
}
